import React from "react";
import { useNavigate } from "react-router-dom";

const NoAccessPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      dir="rtl"
      style={{ minHeight: "85vh" }}
    >
      <div>
        <h1 className=" text-center">
          با عرض پوزش شما به این صفحه دسترسی ندارید!
        </h1>
      </div>
      <div>
        <h4 className=" text-center">
          در صورت داشتن رمز عبور و نام کاربری
          <a href="" onClick={() => navigate("/login")}>
            {" "}
            اینجا{" "}
          </a>
          را کلیک کنید.
        </h4>
      </div>
    </div>
  );
};

export default NoAccessPage;
